import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
// import { receiveRoute } from '@m/cabinet/components/views/utils'
// import Receive from '@m/cabinet/components/views/Receive.vue'

export const STAFF_SETTING_MODEL_PATH = 'setting/'

export const STAFF_SETTING_VIEW_NAME = 'staff:setting'

const STAFF_SETTING_USERS_PREFIX = `${STAFF_SETTING_VIEW_NAME}:setting`

const uPrefix = (name: string) => STAFF_SETTING_USERS_PREFIX + ':' + name

export const STAFF_SETTING_USERS_LIST_VIEW_NAME = uPrefix('list')

const UsersListView = () => import('./Users/List.vue')


export function createSettingRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    prefixRoutes(
      'users/',
      [
        route(
          'list/',
          UsersListView,
          STAFF_SETTING_USERS_LIST_VIEW_NAME,
          {
            meta: {
              title: () => $t('Admin panel users'),
            },
          }
        ),
      ],
      options
    ),
  ]
}
